import 'bootstrap/dist/css/bootstrap.min.css';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import Layout from "../../hocs/layout/Layout";
import NavBar from "../../components/navigation/Navbar";
import Footer from "../../components/navigation/Footer";

import VideosNovedades from "../../components/novedades/videos";

function Videos_Novedades(){
    useEffect(() => {
        window.scrollTo(0,0)
    },[])

    const location = useLocation();
    useEffect(() => {
        if (location.hash) {
            setTimeout(() => {
                const element = document.querySelector(location.hash);
                if (element) {
                    element.scrollIntoView({ behavior: 'smooth', block: 'start' });
                }
            }, 100);
        }
    }, [location]);

    return(
        <Layout>
            <NavBar/>
            <div>
                <VideosNovedades/> 
            </div>
            <Footer/>
        </Layout>
    );
}export default Videos_Novedades;